interface IGetImageObjectFitSizes {
  imgWidth: number;
  imgHeight: number;
  maxWidth: number;
  maxHeight: number;
}

export function getImageObjectFitSizes({
  imgHeight,
  imgWidth,
  maxHeight,
  maxWidth,
}: IGetImageObjectFitSizes) {
  let newWidth: number;
  let newHeight: number;

  const imageRatio = imgWidth / imgHeight;
  const maxRatio = maxWidth / maxHeight;

  if (imageRatio < maxRatio) {
    newHeight = maxHeight;
    newWidth = imgWidth * (maxHeight / imgHeight);
  } else {
    newWidth = maxWidth;
    newHeight = imgHeight * (maxWidth / imgWidth);
  }

  return {
    width: newWidth,
    height: newHeight,
    x: (maxWidth - newWidth) / 2,
    y: (maxHeight - newHeight) / 2,
  };
}

interface CacheEntry {
  promise: Promise<HTMLImageElement | null>;
  timestamp: number;
}

const imageCache = new Map<string, CacheEntry>();
const CACHE_TTL = 5 * 60 * 1000;

export const loadImageFromUrl = (
  url: string,
  forceUpdate: boolean = false
): Promise<HTMLImageElement | null> => {
  if (forceUpdate) {
    imageCache.delete(url);
  } else {
    const cachedEntry = imageCache.get(url);

    if (cachedEntry && Date.now() - cachedEntry.timestamp < CACHE_TTL) {
      return cachedEntry.promise;
    }
  }

  const promise = new Promise<HTMLImageElement | null>((resolve) => {
    const img = new Image();

    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = (error) => {
      console.error('Image load error:', error);
      resolve(null);
    };
    img.src = url;
  });

  imageCache.set(url, { promise, timestamp: Date.now() });

  return promise;
};
